import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../@core/auth/auth.service';
import { CropVariety, CropVarietyCategory, VarietyCustomField } from '../models/crop-variety';

@Injectable({
  providedIn: 'root'
})
export class VarietyService {

  protected basePath = '/';
  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }


  public getCategories(): Observable<CropVarietyCategory[]> {
    return this.httpClient.get<CropVariety[]>(`${this.basePath}/api/cropvarieties/categories`);
  }

  public getVarieties(includeInactive: boolean = false): Observable<CropVariety[]> {
    return this.httpClient.get<CropVariety[]>(`${this.basePath}/api/cropvarieties`);
  }

  public putCropVariety(variety: CropVariety): Observable<CropVariety[]> {
    return this.httpClient.put<CropVariety[]>(`${this.basePath}/api/CropVarieties/${variety.id}`, variety);
  }

  public getCropVariety(id: number): Observable<CropVariety> {
    return this.httpClient.get<CropVariety>(`${this.basePath}/api/cropvarieties/${id}`);
  }

  public deleteCropVariety(id: number) {
    return this.httpClient.delete(`${this.basePath}/api/cropvarieties/${id}`);
  }

  public postCropVariety(CropVariety: CropVariety): Observable<CropVariety[]> {
    return this.httpClient.post<CropVariety[]>(`${this.basePath}/api/CropVarieties`, CropVariety);
  }

  public postCustomField(CustomField: VarietyCustomField): Observable<VarietyCustomField[]> {
    return this.httpClient.post<VarietyCustomField[]>(`${this.basePath}/api/CropVarieties/customfields`, CustomField);
  }
  public putCustomField(CustomFields: VarietyCustomField[]): Observable<VarietyCustomField[]> {
    return this.httpClient.put<VarietyCustomField[]>(`${this.basePath}/api/CropVarieties/customfields`, CustomFields);
  }

  public deleteCropVarietyCustomField(id: number) {
    return this.httpClient.delete(`${this.basePath}/api/cropvarieties/customfields/${id}`);
  }
}
